import React from 'react';
import { usePageLastUpdated } from '../../hooks/usePageLastUpdated';
import './ProjectPage.css';

const PAGE_LAST_UPDATED = { dateTime: '2013-10-09', displayDate: 'October 9, 2013' };

const NavLinks = () => (
  <p className="text-small text-italic text-gray">
    <a href="#top">Go to top</a> | <a href="#contents">Go to contents</a>
  </p>
);

const YtAnalyticsPage = () => {
  usePageLastUpdated(PAGE_LAST_UPDATED);

  const sections = [
    { id: 'browse_videos', title: 'Browse videos', image: 'BrowseVideosSmall.png', caption: 'Browsing videos' },
    { id: 'video_info', title: 'Video information', image: 'VideoInfoSmall.png', caption: 'Video information' },
    { id: 'author_info', title: 'Author information', image: 'AuthorInfoSmall.png', caption: 'Author information' },
    { id: 'views_history', title: 'Views history', image: 'ViewsHistorySmall.png', caption: 'Views history' },
    { id: 'database', title: 'Database', image: 'DatabaseSmall.png', caption: 'Database configuration' },
    { id: 'pl_sites', title: 'PlanetLab', image: 'PlSitesSmall.png', caption: 'PlanetLab sites' },
    { id: 'log', title: 'Logging', image: 'LogSmall.png', caption: 'Logging' },
    { id: 'comments', title: 'Comments', image: 'CommentsSmall.png', caption: 'Comments' },
  ];

  return (
    <div className="project-page" id="top">
      <div className="box" style={{ marginBottom: 'var(--spacing-md)' }}>
        Coming soon
      </div>
      <h1 className="title">YtAnalytics</h1>
      <p>Welcome to YtAnalytics!</p>
      <p>
        YouTube is the world's most popular video sharing web site, and understanding its user activity can have a
        profound impact on designing new content distribution systems. YtAnalytics is a .NET application that allows you
        to browse the collection of YouTube videos, collect statistical data and trends using the built-in tools, and
        perform distributed measurements using the PlanetLab computing platform.
      </p>
      <p>
        YtAnalytics is currently in its final stages of development, and will be available soon. In the meantime, you can
        check below some screenshots to get acquainted with its features.
      </p>

      <h1 id="contents">Contents</h1>
      <ol>
        {sections.map((s) => (
          <li key={s.id}>
            <a href={`#${s.id}`}>{s.title}</a>
          </li>
        ))}
      </ol>
      <NavLinks />

      {sections.map((s) => (
        <React.Fragment key={s.id}>
          <h1 id={s.id}>{s.title}</h1>
          <div>
            <img
              src={`/projects/ytanalytics/images/${s.image}`}
              alt={s.caption}
              width={600}
              height={455}
              style={{ maxWidth: '100%', height: 'auto' }}
            />
            <p className="figure">{s.caption}</p>
          </div>
          <NavLinks />
        </React.Fragment>
      ))}

      <p className="update">Last updated: October 9, 2013</p>
    </div>
  );
};

export default YtAnalyticsPage;
